<template>
  <my-dialog
    @hideMask="$emit('handleSwitchingSchoolDialogClose')"
    :dialogFlag="switchingSchoolDialogFlag"
    width="660px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="switching_school_container">
      <div class="switching_school_container_header">
        <h3 class="header_title">切换学校</h3>
        <div class="close_btn" @click="$emit('handleSwitchingSchoolDialogClose')">
          <img src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png" alt="关闭">
        </div>
      </div>
      <div class="switching_school_container_body">
        <div class="switching_school_container_body_left">
          <div class="list_title">
            <a-checkbox
              :checked="provinceCheckedAll"
              :indeterminate="provinceIndeterminate"
              @change="handleProvinceCheckedAllChange"
            >
              省份
            </a-checkbox>
            <span>{{ provinceSelectList.length }}/{{ provinceIdList.length }}</span>
          </div>
          <div class="list_search">
            <a-input placeholder="请输入省份" v-model="provinceKeywords" @pressEnter="handleProvinceSearch">
              <template #prefix>
                <span @click="handleProvinceSearch">
                  <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png" alt="搜索">
                </span>
              </template>
            </a-input>
          </div>
          <div class="list_body">
            <div v-for="item in provinceListBySearch">
              <a-checkbox :checked="provinceSelectList.includes(item.provinceId)" :disabled="item.schoolCount == 0" @change="handleProvinceCheckedItemChange(item)">{{ item.provinceName }}</a-checkbox>
            </div>
          </div>
        </div>
        <div class="switching_school_container_body_center">
          <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/7713cf6487734ad797281eaefec11656.png" alt="箭头">
        </div>
        <div class="switching_school_container_body_right">
          <div class="list_title">机构</div>
          <div class="list_search">
            <a-input placeholder="请输入学校名" v-model="schoolKeywords" @pressEnter="handleSchoolSearch">
              <template #prefix>
                <span @click="handleSchoolSearch">
                  <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png" alt="搜索">
                </span>
              </template>
            </a-input>
          </div>
          <div class="list_body">
            <div v-for="item in schoolListBySearch">
              <a-radio :checked="schoolSelect === item.schoolId" @change="handleSchoolCheckedItemChange(item)">{{ item.schoolName }}</a-radio>
            </div>
          </div>
        </div>
      </div>
      <div class="switching_school_container_footer">
        <i @click="handleConfirmChoose">确定选择</i>
      </div>
    </div>
  </my-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'switchingSchool',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data () {
    return {
      provinceAllList: [],
      selectSchoolList: [],
      schoolSelect: '',
      schoolSelectName: '',
      provinceCheckedAll: false,
      provinceIndeterminate: false,
      provinceKeywords:'',
      provinceList: [],
      provinceSelectList: [],
      schoolKeywords: '',
      provinceListBySearch: [],
      schoolListBySearch: []
    }
  },
  props: {
    switchingSchoolDialogFlag: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('switchingSchool', {
      schoolSelectStore: 'schoolSelect',
      initSwitchingSchoolFlag: 'initSwitchingSchoolFlag'
    }),
    provinceIdList: function () {
      return this.provinceListBySearch.map(item => item.provinceId)
    }
  },
  methods: {
    ...mapMutations('switchingSchool', {
      setSelectSchoolList: 'setSelectSchoolList',
      setSchoolSelect: 'setSchoolSelect',
      setSchoolSelectName: 'setSchoolSelectName',
      setInitSwitchingSchoolFlag: 'setInitSwitchingSchoolFlag'
    }),
    async getProvinceAllList () {
      try {
        const result = await this.$http.getProvinceList({
          province: this.provinceKeywords
        })
        if (result.code !== 200) return
        this.provinceAllList = result.rt || []
      } catch (err) {
        console.log(err)
      }
    },
    async getSelectSchoolList () {
      try {
        const result = await this.$http.getSelectSchoolList()
        if (result.code !== 200) return
        this.selectSchoolList = result.rt || []
        this.setSelectSchoolList(this.selectSchoolList)
        this.schoolListBySearch = JSON.parse(JSON.stringify(this.selectSchoolList))
        if (!this.initSwitchingSchoolFlag) {
          this.schoolSelect = this.selectSchoolList[0]?.schoolId || ''
          this.schoolSelectName = this.selectSchoolList[0]?.schoolName || ''
          this.setSchoolSelect(this.schoolSelect)
          this.setSchoolSelectName(this.schoolSelectName)
          this.setInitSwitchingSchoolFlag(true)
        } else {
          this.schoolSelect = this.schoolSelectStore
        }
        const provinceIdBySelectSchoolList = Array.from(new Set(this.selectSchoolList.map(item => Number(item.provinceId))))
        const provinceAllListMap = new Map()
        this.provinceAllList.forEach(item => {
          provinceAllListMap.set(item.provinceId, item)
        })
        this.provinceList = provinceIdBySelectSchoolList.map(item => provinceAllListMap.get(item))
        this.provinceListBySearch = JSON.parse(JSON.stringify(this.provinceList))
        this.provinceCheckedAll = true
        this.provinceSelectList = this.provinceIdList
      } catch (err) {
        console.log(err)
      }
    },
    handleProvinceCheckedAllChange (e) {
      const checked = e.target.checked
      if (checked) {
        this.provinceCheckedAll = true
        this.provinceSelectList = this.provinceIdList
      } else {
        this.provinceCheckedAll = false
        this.provinceSelectList = []
      }
      this.provinceIndeterminate = false
      this.handleSchoolSearch()
    },
    handleProvinceCheckedItemChange (item) {
      if (this.provinceSelectList.includes(item.provinceId)) {
        const provinceSet = new Set(this.provinceSelectList)
        provinceSet.delete(item.provinceId)
        this.provinceSelectList = Array.from(provinceSet)
      } else {
        this.provinceSelectList.push(item.provinceId)
      }
      if (this.provinceSelectList.length !== this.provinceIdList.length) {
        this.provinceCheckedAll = false
        if (this.provinceSelectList.length) {
          this.provinceIndeterminate = true
        } else {
          this.provinceIndeterminate = false
        }
      } else {
        this.provinceCheckedAll = true
        this.provinceIndeterminate = false
      }
      this.handleSchoolSearch()
    },
    handleProvinceSearch () {
      this.provinceListBySearch = this.provinceList.filter(item => item.provinceName.includes(this.provinceKeywords))
      this.provinceCheckedAll = false
      this.provinceIndeterminate = false
      this.provinceSelectList = []
      this.handleSchoolSearch()
    },
    handleSchoolSearch () {
      this.schoolListBySearch = this.selectSchoolList.filter(item => this.provinceSelectList.includes(Number(item.provinceId))).filter(item => item.schoolName.includes(this.schoolKeywords))
      if (!this.schoolListBySearch.map(item => item.schoolId).includes(this.schoolSelect)) {
        this.schoolSelect = ''
      }
    },
    handleSchoolCheckedItemChange (item) {
      this.schoolSelect = item.schoolId
    },
    handleConfirmChoose () {
      if (!this.schoolSelect) return this.$message.error('请选择机构')
      const result  = this.schoolListBySearch.find(item => item.schoolId === this.schoolSelect)
      this.schoolSelectName = result?.schoolName
      this.setSchoolSelect(this.schoolSelect)
      this.setSchoolSelectName(this.schoolSelectName)
      this.$emit('handleSwitchingSchoolDialogClose', true)
    }
  },
  async created () {
    await this.getProvinceAllList()
    await this.getSelectSchoolList()
  },
  activated () {
   this.schoolSelect = this.schoolSelectStore
  }
}
</script>

<style lang="scss" scoped>
  .switching_school_container {
    text-align: left;
    .switching_school_container_header {
      width: 100%;
      height: 60px;
      border-radius: 8px 8px 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      border-bottom: 2px solid #EAEAEA;
      .header_title {
        font-size: 16px;
        font-weight: 500;
        color: #1E2228;
      }
      .close_btn {
        width: 12px;
        height: 12px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
    .switching_school_container_body {
      width: 100%;
      height: 415px;
      padding: 8px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .switching_school_container_body_left,
      .switching_school_container_body_right {
        width: 240px;
        height: 100%;
        display: flex;
        flex-direction: column;
        .list_title {
          width: 100%;
          height: 38px;
          background: #F6F8FA;
          border-radius: 4px 4px 0px 0px;
          display: flex;
          padding: 0 12px;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          font-weight: 500;
          color: #1E2228;
          > span {
            font-size: 14px;
            color: #9CA5B1;
          }
          ::v-deep.ant-checkbox-wrapper {
            > span:nth-child(2) {
              font-size: 14px;
              font-weight: 500;
              color: #1E2228;
            }
          }
          ::v-deep.ant-checkbox-checked {
            .ant-checkbox-inner {
              background-color: #5f60d3;
              border-color: transparent;
            }
          }
          ::v-deep.ant-checkbox-indeterminate {
            .ant-checkbox-inner {
              &::after {
                background-color: #5f60d3;
              }
            }
          }
        }
        .list_search {
          width: 100%;
          height: auto;
          border: 1px solid #F6F8FA;
          padding: 8px 8px;
          ::v-deep.ant-input-affix-wrapper {
            padding: 0 8px;
            .ant-input-prefix {
              img {
                width: 24px;
                height: 24px;
                display: block;
              }
            }
            .ant-input {
              border-radius: 19px !important;
              border: 1px solid #E3E8EC;
            }
          }
        }
        .list_body {
          flex: 1;
          border: 1px solid #F6F8FA;
          border-radius: 0px 0px 4px 4px;
          overflow-y: scroll;
          > div {
            padding: 11px 12px;
            ::v-deep.ant-checkbox-checked {
              .ant-checkbox-inner {
                background-color: #5f60d3;
                border-color: #5f60d3;
              }
            }
            ::v-deep.ant-radio-checked {
              .ant-radio-inner {
                border-color: #5f60d3;
              }
              .ant-radio-inner::after {
                background-color: #5f60d3;
              }
            }
          }
        }
      }
      .switching_school_container_body_center {
        padding: 0 20px;
        img {
          width: 24px;
          height: 24px;
          display: block;
        }
      }
    }
    .switching_school_container_footer {
      width: 100%;
      height: 75px;
      border-radius: 0 0 8px 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-top: 2px solid #EAEAEA;
      i {
        width: 104px;
        height: 38px;
        background: #5F60D3;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFF;
        cursor: pointer;
        user-select: none;
        &:hover {
          background: #434499;
        }
        &:active {
          background: #5F60D3;
        }
      }
    }
  }
</style>